import React, { useState, useEffect, useRef } from 'react';
import Card from '../../components/Card/Card';
import { connect } from 'react-redux';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import * as actions from '../../store/actions/actions';
import classes from './Map.css';

const Map = (props) => {
	
  const MapContainer = useRef(null);
  let transformedData = props.countries.map((v,i) => {
  	   return {
	  		type: 'Feature',
		    geometry: {
		      type: 'Point',
		      coordinates: [v.countryInfo.long, v.countryInfo.lat]
		    },
		    properties: {
		      title: v.country,
		      description: `Active Cases: ${v.cases}`
		    }
  	   }
  })

  let geojson = {
	  type: 'FeatureCollection',
	  features: transformedData
  };
  
  useEffect(() => {
  	      props.onGetMapAsync();
          if (!props.loading) {
	  	      mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
		      const COVIDMap = new mapboxgl.Map({
				  container: MapContainer.current,
				  style: 'mapbox://styles/mapbox/dark-v10',
				  center: [0,0],
				  zoom: 1
			  });
			  COVIDMap.addControl(new mapboxgl.NavigationControl());

	          geojson.features.forEach((v, i) => {
               		const marker = new mapboxgl.Marker({ draggable: true, color: "red" })
	                .setLngLat(v.geometry.coordinates)
	                .setPopup(new mapboxgl.Popup({ offset: 25}) 
                    .setHTML('<h3>' + v.properties.title + '</h3><p>' + v.properties.description + '</p>'))
	                .addTo(COVIDMap);

	           return () => COVIDMap.remove();  
	        })
	      }     

  }, [props.loading])

	return (
		<div>
		{props.loading && <div className={classes.Spinner}></div>}
		{props.error && <p className={classes.Error}> { props.error.message }</p>}
        <div ref={ el => MapContainer.current = el } className={classes.MapContainer}></div>
        </div>
	)
}

const mapStateToProps = state => {
  return {
  	countries: state.mapReducer.mapData.countries,
  	timestamp: state.mapReducer.mapData.timestamp,
  	loading: state.mapReducer.mapData.loading,
  	error: state.mapReducer.error
  }
}

const mapDispatchToProps = dispatch => {
	return {
		onGetMapAsync: () => dispatch(actions.getMapAsync())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Map);


// WEBPACK FOOTER //
// ./src/containers/Map/Map.js